import { render, staticRenderFns } from "./_template-dashboard-selector.vue?vue&type=template&id=1d9d98ad&scoped=true&"
import script from "./_template-dashboard-selector.vue?vue&type=script&lang=js&"
export * from "./_template-dashboard-selector.vue?vue&type=script&lang=js&"
import style0 from "./_template-dashboard-selector.vue?vue&type=style&index=0&id=1d9d98ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d98ad",
  null
  
)

export default component.exports